import { addPointInteger } from 'vlcishared';

export const OPTIONS_GAUGE_MONTH = {
  title: {
    text: '',
    left: 'center',
    top: 'top',
    padding: 10,
    textStyle: {
      fontSize: 12,
      fontFamily: 'Montserrat',
      fontWeight: 600,
      color: '#666',
    },
  },
  series: {
    type: 'gauge',
    startAngle: -180,
    endAngle: 0,
    splitNumber: 2,
    max: undefined,
    itemStyle: {
      color: '#FFAB91',
    },
    progress: {
      show: true,
      width: 30,
    },
    pointer: {
      show: false,
    },
    axisLine: {
      lineStyle: {
        width: 30,
      },
    },
    axisTick: {
      distance: 5,
      splitNumber: 10,
      lineStyle: {
        width: 2,
        color: '#999',
      },
    },
    splitLine: {
      distance: 10,
      length: 14,
      lineStyle: {
        width: 3,
        color: '#999',
      },
    },
    axisLabel: {
      fontFamily: 'Montserrat',
      color: '#666',
      fontSize: 14,
      show: true,
      distance: 40,
      formatter: (value) => addPointInteger(Math.round(value)),
    },
    anchor: {
      show: false,
    },
    title: {
      show: false,
    },
    detail: {
      valueAnimation: true,
      width: '60%',
      lineHeight: 40,
      borderRadius: 8,
      offsetCenter: [0, '0%'],
      fontSize: 17,
      fontWeight: 'bolder',
      formatter: undefined,
      fontFamily: 'Montserrat',
      color: 'inherit',
    },
    data: undefined,
  },
  toolbox: {
    show: true,
    feature: {
      saveAsImage: { title: 'Desar' },
    },
    right: 27,
    top: 40,
  },
};
